import { useEffect } from "react";
import { useRouter } from "next/router";
import useAuth from "../../hooks/useAuth";

const LoginRedirect = ({ children }) => {
  const router = useRouter();
  const { isAuthenticated, roleName } = useAuth();

  useEffect(() => {
    if (isAuthenticated && roleName) {
      // Map root users to admin dashboard since they have admin access
      const dashboardRole = roleName === "root" ? "admin" : roleName;
      router.replace("/" + dashboardRole + "/dashboard/overview");
    }
  }, [isAuthenticated, roleName, router]);

  return <>{children}</>;
};

export default LoginRedirect;
